import React from 'react';
import { useModal } from '../../../../../components/Modal/PresentedModal';
import { FormForm } from '../../../../../components/Form/FormForm';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { graphql } from '../../../../../generated';
import { useMutation } from '@apollo/client';
import { t } from '../../../../../locales/translate';
import { Text } from '../../../../../components/text/text';
import { handleError } from '../../../../../model/notification';

const CAPTURE_PAYMENT = graphql(`
  mutation CapturePayment($paymentId: ID!) {
    processPaymentAuthorization(input: { paymentId: $paymentId, action: CAPTURE }) {
      clientMutationId
    }
  }
`);

interface Props {
  paymentId: string;
  onClose?: () => void;
}

export function CapturePaymentModal({ paymentId, onClose }: Props): JSX.Element {
  const { open, Modal, close, size } = useModal();
  const [sendRequest] = useMutation(CAPTURE_PAYMENT);
  const { onSubmit, submissionStatus } = useForm({
    model: {},
    onSubmit: async () => {
      await sendRequest({
        variables: { paymentId },
      });
      close();
      onClose?.();
    },
    onSubmitError: handleError,
  });

  return (
    <Modal open={open} size={size} title={t.model.order.capturePayment.title}>
      <FormForm
        onSubmit={onSubmit}
        onClose={close}
        canSubmit
        loading={submissionStatus === 'submitting'}
        saveButtonTitle={t.model.order.capturePayment.confirm}
      >
        <Text type="card-text">{t.model.order.capturePayment.description}</Text>
      </FormForm>
    </Modal>
  );
}
